import { createGenerateClassName } from '@material-ui/core/styles'

// MUI v4 and v5 both emit the shared 'MuiXxx-<rule>' names, and both number their production class
// names from 'jss1'. Seeding the v4 generator keeps the two apart: install it on every React root
// that renders v4 components, not just the main one.
export const muiV4GenerateClassName = createGenerateClassName({ seed: 'v4' })
